import React from "react";
import { PROJECT_WEB_FONT_FAMILIES } from "../projectTypographyCatalog";

const SAMPLE = "Alugue com a 7Cantos — Aa Bb 012";

export const ProjectTypographySection: React.FC = () => (
  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
    {PROJECT_WEB_FONT_FAMILIES.map((family) => (
      <div
        key={family}
        className="rounded-lg border border-[#E2E8F0] bg-white px-4 py-3 shadow-sm"
      >
        <p className="text-xs font-medium text-[#718096]">{family}</p>
        <p className="mt-1 text-base text-[#2D3748]" style={{ fontFamily: `'${family}', sans-serif` }}>
          {SAMPLE}
        </p>
      </div>
    ))}
  </div>
);
